<template>
    <div class="forbidpage">
        <span @click="goLogin" class="iconfont close-icon">&#xe68e;</span>
        <img src="@/assets/img/forbid-icon.png" alt="">
        <h1>您的账号使用受限</h1>
        <p>如有疑问,请联系客服</p>
        <div @click="goLogin" class="button">退出</div>
    </div>
</template>
<script>
import { bridge } from '@/utils/util';
export default {
    methods:{
        goLogin(){
            if(localStorage.getItem('s') === 'BS'){
                let baseUrl = 'jsb://action=goBack'
				bridge(baseUrl)
            }else{
                this.$router.replace({
                    path:'/login'
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.forbidpage{
        .close-icon{
    padding:50px 0 0 16px;
    font-size: 16px;
    display: inline-block;
}
    img{
        width:60px;
        height: 60px;
        display: block;
        margin:60px auto 20px;
    }
    h1{
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
    text-align: center;
    }
    p{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
    text-align: center;
    margin-top:20px;
    }
    .button{
        width: 315px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #DDDDDD;
        line-height: 40px;
        text-align: center;
        margin: 120px auto 0;
    }
}
</style>